import React from 'react';
import { Link } from "react-router-dom";
import {
	Card,
	Input,
	Button,
	Table,
	Modal,
	message,
	Alert,
	Tag,
	Tooltip,
	Typography,
	Pagination,
	Select,
	Spin,
} from 'antd';
import {
	SearchOutlined,
	PlusOutlined,
	FormOutlined,
	CloseSquareOutlined,
	ExclamationCircleOutlined,
	SettingOutlined,
	RedoOutlined,
	CalculatorOutlined,
	CarOutlined,
	FilterOutlined,
	ClusterOutlined,
	AppstoreOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data NJKB',
	apiUrl: {
		data: 'kendaraan/api/perhitungan/',
		jenis: 'master/api/jenis/kendaraan/',
		merek: 'master/api/merek/',
		tipe: 'master/api/tipe/',
	},
	pageUrl: { form: '/admin/njkb/form/' },
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'NJKB',
	],
};

const config = new Config();

class DataNjkb extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
			// filter dropdown
			filterJenis: null,
			filterMerek: null,
			filterTipe: null,
			loadingJenis: false,
			listJenis: [],
			loadingMerek: false,
			listMerek: [],
			loadingTipe: false,
			listTipe: [],
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this.loadJenisList();
		this.loadMerekList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	loadJenisList() {
		this.setState({ loadingJenis: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.jenis + '?limit=10000')
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listJenis: data.results || (Array.isArray(data) ? data : []) });
				}
				this.setState({ loadingJenis: false });
			})
			.catch(() => { this.setState({ loadingJenis: false }); });
	}

	loadMerekList() {
		this.setState({ loadingMerek: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.merek + '?limit=10000')
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listMerek: data.results || (Array.isArray(data) ? data : []) });
				}
				this.setState({ loadingMerek: false });
			})
			.catch(() => { this.setState({ loadingMerek: false }); });
	}

	loadTipeByFilter(jenisId, merekId) {
		const jenis = jenisId || this.state.filterJenis;
		const merek = merekId !== undefined ? merekId : this.state.filterMerek;
		if (!jenis && !merek) {
			this.setState({ listTipe: [], filterTipe: null });
			return;
		}
		this.setState({ loadingTipe: true, listTipe: [], filterTipe: null });
		let url = configClass.apiUrl.tipe + '?limit=10000&';
		if (jenis) url += 'jenis=' + jenis + '&';
		if (merek) url += 'merek=' + merek;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listTipe: data.results || (Array.isArray(data) ? data : []) });
				}
				this.setState({ loadingTipe: false });
			})
			.catch(() => { this.setState({ loadingTipe: false }); });
	}

	handleFilterJenisChange = (val) => {
		this.setState(
			prev => ({ filterJenis: val || null, filterTipe: null, listTipe: [], pagination: { ...prev.pagination, current: 1 } }),
			() => {
				this.loadTipeByFilter(val || null, this.state.filterMerek);
				this.getData(this.state.pagination.pageSize, 0, this.state.searchText, val || null, this.state.filterMerek, null);
			}
		);
	};

	handleFilterMerekChange = (val) => {
		this.setState(
			prev => ({ filterMerek: val || null, filterTipe: null, listTipe: [], pagination: { ...prev.pagination, current: 1 } }),
			() => {
				this.loadTipeByFilter(this.state.filterJenis, val || null);
				this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.filterJenis, val || null, null);
			}
		);
	};

	handleFilterTipeChange = (val) => {
		this.setState(
			prev => ({ filterTipe: val || null, pagination: { ...prev.pagination, current: 1 } }),
			() => {
				this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.filterJenis, this.state.filterMerek, val || null);
			}
		);
	};

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus',
			icon: <ExclamationCircleOutlined />,
			content: 'Yakin ingin menghapus data NJKB ini?',
			okText: 'Hapus',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data NJKB berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menghapus data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async getData(
		limit = this.state.pagination.pageSize,
		offset = 0,
		search = this.state.searchText,
		jenis = this.state.filterJenis,
		merek = this.state.filterMerek,
		tipe = this.state.filterTipe,
	) {
		this.setState({ loadingData: true });
		let url = configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search;
		if (jenis) url += '&jenis=' + jenis;
		if (merek) url += '&merek=' + merek;
		if (tipe) url += '&tipe=' + tipe;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	handleReset = () => {
		this.setState(
			prev => ({ searchText: '', filterJenis: null, filterMerek: null, filterTipe: null, listTipe: [], pagination: { ...prev.pagination, current: 1 } }),
			() => this.getData(this.state.pagination.pageSize, 0, '', null, null, null)
		);
	};

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>;
				},
			},
			{
				title: 'Jenis',
				dataIndex: 'tipe_jenis_nama',
				key: 'tipe_jenis_nama',
				width: 130,
				render: (val) => val ? (
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<ClusterOutlined style={{ color: '#52c41a', fontSize: 12, flexShrink: 0 }} />
						<Text style={{ fontSize: 13 }}>{val}</Text>
					</div>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Kode',
				dataIndex: 'tipe_kode',
				key: 'tipe_kode',
				width: 130,
				render: (val) => (
					<Tag style={{
						borderRadius: 20, fontWeight: 600, fontSize: 11,
						background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a',
						letterSpacing: 0.5, fontFamily: 'monospace',
						whiteSpace: 'normal', wordBreak: 'break-all',
					}}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Tipe',
				dataIndex: 'tipe_nama',
				key: 'tipe_nama',
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<div style={{
							width: 30, height: 30, borderRadius: 8, flexShrink: 0,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center',
						}}>
							<CalculatorOutlined style={{ color: '#fff', fontSize: 13 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{
				title: 'Merek',
				dataIndex: 'merek_nama',
				key: 'merek_nama',
				width: 130,
				render: (val) => val ? (
					<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
						<CarOutlined style={{ color: '#1e4d8a', fontSize: 12, flexShrink: 0 }} />
						<Text style={{ fontSize: 13 }}>{val}</Text>
					</div>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Golongan',
				key: 'golongan',
				width: 100,
				render: (_, row) => row.golongan_kode ? (
					<Tooltip title={row.golongan_nama || row.golongan_kode}>
						<Tag style={{
							borderRadius: 8, fontSize: 11,
							background: '#f9f0ff', borderColor: '#d3adf7', color: '#722ed1',
							cursor: 'default', fontWeight: 600,
						}}>
							{row.golongan_kode}
						</Tag>
					</Tooltip>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Th. Buat',
				dataIndex: 'tahun_buat',
				key: 'tahun_buat',
				width: 80,
				align: 'center',
				render: (val) => (
					<Tag style={{ borderRadius: 20, fontSize: 11, background: '#e6f7ff', borderColor: '#91d5ff', color: '#0050b3' }}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Nilai NJKB',
				dataIndex: 'njkb',
				key: 'njkb',
				width: 155,
				align: 'right',
				render: (val) => (
					<Text style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 600, color: '#0f2847' }}>
						{val != null ? 'Rp ' + Number(val).toLocaleString('id-ID') : '—'}
					</Text>
				),
			},
			{
				title: 'Bobot',
				dataIndex: 'bobot',
				key: 'bobot',
				width: 70,
				align: 'center',
				render: (val) => (
					<Tag style={{ borderRadius: 20, fontSize: 11, background: '#fff7e6', borderColor: '#ffd591', color: '#d46b08' }}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 90,
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Edit">
							<Link to={configClass.pageUrl.form + row.id}>
								<Button size="small" shape="circle" type="primary" ghost><FormOutlined /></Button>
							</Link>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<CalculatorOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>{row.tipe_nama || '—'}</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
							{row.merek_nama && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>
									<CarOutlined style={{ marginRight: 3 }} />{row.merek_nama}
								</Tag>
							)}
							{row.golongan_nama && (
								<Tag style={{
									borderRadius: 8, fontSize: 11, margin: 0,
									color: '#722ed1', borderColor: '#d3adf7', background: '#f9f0ff',
									whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '18px',
								}}>
									{row.golongan_nama}
								</Tag>
							)}
							{row.tahun_buat && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, color: '#0050b3', borderColor: '#91d5ff', background: '#e6f7ff' }}>
									{row.tahun_buat}
								</Tag>
							)}
						</div>
						<div style={{ marginTop: 6, fontSize: 13, fontWeight: 600, color: '#0f2847', fontFamily: 'monospace' }}>
							Rp {Number(row.njkb || 0).toLocaleString('id-ID')}
							<Text type="secondary" style={{ fontSize: 11, fontFamily: 'sans-serif', fontWeight: 400, marginLeft: 8 }}>
								bobot: {row.bobot}
							</Text>
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title="Edit">
							<Link to={configClass.pageUrl.form + row.id}>
								<Button size="middle" shape="circle" type="primary" ghost><FormOutlined /></Button>
							</Link>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const {
			errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText,
			filterJenis, filterMerek, filterTipe,
			listJenis, listMerek, listTipe,
			loadingJenis, loadingMerek, loadingTipe,
		} = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-njkb-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px;
							color: #0f2847; border-bottom: 2px solid #d0dff5;
						}
						.data-njkb-wrap .ant-table-tbody > tr > td { padding: 12px 16px; vertical-align: middle; }
						.data-njkb-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-njkb-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-njkb-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-njkb-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* ── Header ── */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<CalculatorOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} data NJKB{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => this.setState(
										prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
										() => this.getData(this.state.pagination.pageSize, 0, '')
									)}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button type="primary" icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah NJKB'}
								</Button>
							</Link>
						</div>
					</div>

					{/* ── Filter dropdown ── */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #eef2ff', background: '#f8faff',
						display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#1e4d8a', fontSize: 13, fontWeight: 600, flexShrink: 0 }}>
							<FilterOutlined />
							<span>Filter:</span>
						</div>
						<Select
							placeholder={<span><ClusterOutlined style={{ marginRight: 5 }} />Semua Jenis</span>}
							allowClear
							style={{ minWidth: isMobile ? '100%' : 220, borderRadius: 8 }}
							value={filterJenis}
							loading={loadingJenis}
							onChange={this.handleFilterJenisChange}
							showSearch
							optionFilterProp="children"
							notFoundContent={loadingJenis
								? <Spin size="small" />
								: <span style={{ color: '#aaa', fontSize: 12 }}>Tidak ada data</span>
							}
						>
							{listJenis.map(item => (
								<Select.Option key={item.id} value={item.id}>
									{item.kode ? item.kode + ' - ' + item.nama : item.nama}
								</Select.Option>
							))}
						</Select>
						<Select
							placeholder={<span><CarOutlined style={{ marginRight: 5 }} />Semua Merek</span>}
							allowClear
							style={{ minWidth: isMobile ? '100%' : 200, borderRadius: 8 }}
							value={filterMerek}
							loading={loadingMerek}
							onChange={this.handleFilterMerekChange}
							showSearch
							optionFilterProp="children"
							notFoundContent={loadingMerek
								? <Spin size="small" />
								: <span style={{ color: '#aaa', fontSize: 12 }}>Tidak ada data</span>
							}
						>
							{listMerek.map(item => (
								<Select.Option key={item.id} value={item.id}>
									{item.kode ? item.kode + ' - ' + item.nama : item.nama}
								</Select.Option>
							))}
						</Select>
						<Select
							placeholder={<span><AppstoreOutlined style={{ marginRight: 5 }} />Semua Tipe</span>}
							allowClear
							style={{ minWidth: isMobile ? '100%' : 260, borderRadius: 8 }}
							value={filterTipe}
							disabled={!filterJenis && !filterMerek}
							loading={loadingTipe}
							onChange={this.handleFilterTipeChange}
							showSearch
							optionFilterProp="children"
							notFoundContent={loadingTipe ? <Spin size="small" /> : 'Tidak ada data'}
						>
							{listTipe.map(item => (
								<Select.Option key={item.id} value={item.id}>
									{item.kode ? item.kode + ' - ' + item.nama : item.nama}
								</Select.Option>
							))}
						</Select>
						{(filterJenis || filterMerek || filterTipe) && (
							<Button size="small" onClick={this.handleReset}
								style={{ borderRadius: 8, color: '#ff4d4f', borderColor: '#ff4d4f', flexShrink: 0 }}>
								Reset Filter
							</Button>
						)}
					</div>

					{/* ── Search bar ── */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari tipe, merek, golongan..."
							allowClear size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 340 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => this.setState(
								prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
								() => this.getData(this.state.pagination.pageSize, 0, '')
							)}
						/>
					</div>

					{/* ── Konten ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize}
											total={pagination.total} onChange={this.handleMobilePageChange}
											showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataNjkb);
